import { gql } from "@apollo/client";

import { remoteAssetFragment } from "../fragments/remoteAssetFragment";

export const updateRemoteAssetMutation = gql`
    mutation updateRemoteAsset($id: ID!, $name: String!, $description: String!, $forkingAllowed: Boolean) {
        updateRemoteAsset(input: { id: $id, name: $name, description: $description, forkingAllowed: $forkingAllowed }) {
            ...RemoteAssetFields
        }
    }
    ${remoteAssetFragment}
`;
